import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Humidity',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M.85 21.09c-.19-.47-.34-.96-.47-1.45H32c0 .5-.05.98-.13 1.45H.85zM6.01 6.55a11.64 11.64 0 0 1 11.25 0H6.01zM.1 15.27c.06-.5.16-.98.28-1.45h29.38c.4.45.76.93 1.06 1.45H.1zm.75-2.91c.2-.5.45-.99.72-1.45H21.7l.09.15c.48-.08.97-.15 1.48-.15 1.78 0 3.44.54 4.82 1.45H.85zm1.71-2.91c.42-.52.89-1 1.4-1.45h15.36c.5.44.96.93 1.38 1.45H2.56zm29.31 8.73H.1c-.06-.48-.1-.96-.1-1.45h31.49c.17.47.29.95.38 1.45zm-.38 4.37c-.18.51-.4.99-.67 1.45H2.56c-.37-.46-.7-.94-.99-1.45h29.92zm-27.53 2.9h25.81c-.49.55-1.05 1.04-1.67 1.45H6.01c-.74-.4-1.42-.89-2.05-1.45z" }
      })]
    );
  }
};